import { useEffect, useRef } from "react";
import { useBackButtonStore } from "@/store/back-button-store";

export function useBackButton(handler: () => void, enabled = true) {
  const handlerRef = useRef(handler);
  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    if (!enabled) return;
    const id = useBackButtonStore.getState().push(() => handlerRef.current());
    return () => useBackButtonStore.getState().remove(id);
  }, [enabled]);
}
